import * as React from "react";
// import { useState, useContext, createContext, useEffect } from "react";

const useStateWithCallback = (initialState, callback) => {
    const [state, setState] = React.useState(initialState);
    const didMount = React.useRef(false);
    React.useEffect(() => {
      if (didMount.current) {
        callback(state);
      } else {
        didMount.current = true;
      }
    }, [state, callback]);
    return [state, setState];
  };

  export default useStateWithCallback;